import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import metadata from './AgentSelectionPopup.metadata.json5';
import messages from './AgentSelectionPopup.messages';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { MLModalService } from 'ml-portals-services-react';
import {useAuthentication} from '@xengage/gw-digital-auth-react';



function AgentSelectionPopup(props) {
    const {
        submissionVM, id, onCancel, producersList, path, viewModelService, setSpecialityVehicleList, updateWizardData, onNext, onSave
    } = props;
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const [currentAgent, setCurrentAgent] = useState()
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const {authHeader} = useAuthentication();
    const errorMessage = translator(messages.indicativeQuoteFailure)
    const [showIndicativeError, setShowIndicativeError] = useState(false)

        const {
            showProgressDialog,
        } = MLModalService();

    useEffect(()=>{
         const isAgentPresent = _.get(submissionVM, 'lobData.personalAuto.specialtyCrossSell_ML.selectedAgent.producerCode')?.value
        if(isAgentPresent) {
            setCurrentAgent(isAgentPresent)
        }
    },[])


    const onSaveDetails = async () => {
        if(!isComponentValid) return;

        setShowIndicativeError(false)
        const selectedAgent = _.get(submissionVM, 'lobData.personalAuto.specialtyCrossSell_ML.selectedAgent')
        const sessionUUID = _.get(submissionVM, 'sessionUUID.value');
        const quoteID = _.get(submissionVM, 'quoteID.value');
        const specialtyCrossSell_ML = _.get(submissionVM, 'lobData.personalAuto.specialtyCrossSell_ML.value');

        const indicativeQuotePromise = LoadSaveService.getIndicativeQuote_Ext(quoteID, sessionUUID, specialtyCrossSell_ML, authHeader)
        showProgressDialog(indicativeQuotePromise.loading, indicativeQuotePromise);
        indicativeQuotePromise.then((response) => {
            const indicativeError = _.get(
                response,
                'lobData.personalAuto.specialtyCrossSell_ML.indicativeQuoteError'
            );
 
            if (indicativeError) {
                setShowIndicativeError(true);
                return;
            }
             const specialtyVehicles = _.get(
                response,
                'lobData.personalAuto.specialtyCrossSell_ML.specialtyVehicles'
            );
            if(specialtyVehicles) {
                const path = 'lobData.personalAuto.specialtyCrossSell_ML.specialtyVehicles.value'
                setSpecialityVehicleList(specialtyVehicles ?? [])
                _.set(submissionVM, path, specialtyVehicles)
                updateWizardData(submissionVM)
            }
            onSave?.()
            onNext()
        }).catch((e)=>{
            setShowIndicativeError(true)
        })
    };

    const resolvers = {
        resolveCallbackMap: {
            onSaveDetails: onSaveDetails,
            onCancel: onCancel
        }
    };

    const writeValue = (value, path) => {
        _.set(submissionVM.value, path, value);
        _.set(submissionVM, path, value);
        refreshData();
    };

    const overrides = {
        nextButton: {
           disabled: !currentAgent
        },
        indicativeError: {
            visible: showIndicativeError,
            content: errorMessage,
            componentProps:{
                style: {
                    display: showIndicativeError ? 'block' : 'none' 
                },
            }
        },
        agentSelection: {
            availableValues: producersList,
            path,
            value: currentAgent,
            validation: [
                {
                   type: 'required',
                   message: {
                    id: "ml.agentSelection.required",
                    defaultMessage: "Please select a producer code."
                   }
                }

            ],
            onValueChange: (val) => {
                setShowIndicativeError(false)
                if (!val) {
                     const newSubmissionVM = viewModelService.clone(submissionVM)
                     const vm = newSubmissionVM?.value ?? newSubmissionVM
                    _.set(vm, 'lobData.personalAuto.specialtyCrossSell_ML.selectedAgent', { producerCode: '' });
                    _.set(vm, 'lobData.personalAuto.specialtyCrossSell_ML.selectedAgent.producerCode', '');
                    updateWizardData(newSubmissionVM)
                    refreshData()
                    setCurrentAgent('') 
                } else {
                    const selectedVal = producersList.find((item) => item.code === val)
                    _.set(submissionVM, 'lobData.personalAuto.specialtyCrossSell_ML.selectedAgent.value', { ...selectedVal, producerCode: val });
                    _.set(submissionVM, 'lobData.personalAuto.specialtyCrossSell_ML.selectedAgent.producerCode.value', val);
                    updateWizardData(submissionVM);
                    refreshData()
                    setCurrentAgent(val)
                }
            }

        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            showErrors
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

AgentSelectionPopup.propTypes = {
    model: PropTypes.shape({}).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
export default AgentSelectionPopup;
